<template>
<v-card class="elevation-1">
  <v-card-media class="secondary--text text-xs-left" height="175px" src="/static/img/Rophem-LMS-Background.jpg">
    <v-layout column>
      <v-spacer></v-spacer>
      <div class="title-bg px-3 pt-2 text-xs-center">
        <div class="headline half-spaced"><b>{{courseData.name}}</b></div>
        <div v-if="courseData.type == 'Online'" class="subheading caps half-spaced"><b>online</b></div>
        <div v-else class="subheading">
          <span v-for="date, i in courseData.dates" :key="i"><b>{{date}}</b>{{i < courseData.dates.length - 1 ? ', ' : ''}}</span>
        </div>
      </div>
    </v-layout>
  </v-card-media>
  <v-layout row wrap justify-center>
    <v-flex class="pt-2 px-2 text-xs-center" xs12>
      <div class="subheading half-spaced"><b>{{getTimeLeft(progress.endTime, courseData.onlineDays)}}</b></div>
    </v-flex>
    <v-flex class="text-xs-left" xs6>
      <v-btn 
        v-if="progress.endTime > 0"
        @click.native="goToCourse(progress.key)"
        class="subheading half-spaced"
        color="success"
        :disabled="now > progress.endTime"
        flat
      ><b>Continue</b><v-icon>arrow_right</v-icon></v-btn>
      <v-btn v-else @click.native="startCourse(progress)" class="subheading half-spaced" color="success" flat>
        <b>Start</b>
        <v-icon>arrow_right</v-icon>
      </v-btn>
    </v-flex>
    <v-flex class="text-xs-right" xs6>
      <v-btn @click.native="expanded = !expanded" color="primary" flat :icon="expanded" :ripple="false">
        <v-icon v-if="expanded">expand_less</v-icon>
        <span class="half-spaced" v-else><b>Details</b></span>
      </v-btn>
    </v-flex>
  </v-layout>

  <v-slide-y-transition>
    <v-layout v-show="expanded" class="text-xs-left px-3" row wrap justify-center>
      <v-flex class="pb-1" xs4>
        <v-divider></v-divider>
      </v-flex>
      <v-flex v-if="courseData.type == 'Live'" class="py-2 subheading" xs12>
        <div class="caps half-spaced"><b>course details</b></div>
        <div><b>Dates:</b> <span v-for="date, i in courseData.dates" :key="date">{{date}}{{i < courseData.dates.length - 1 ? ', ' : ''}}</span></div>
        <div><b>Time:</b> {{courseData.startTime + ' to ' + courseData.endTime}}</div>
        <div><b>Location:</b> {{courseData.location}}</div>
      </v-flex>
      <v-flex v-if="courseContent.length > 0" class="py-2 subheading" xs12>
        <div class="caps half-spaced"><b>course content</b></div>
        <div v-for="content in courseContent" class="-text-xs-left">
          <div class="half-spaced"><b><u>{{content.name}}</u></b></div>
          <div class="quill-card" v-html="content.descText"></div>
        </div>
      </v-flex>
    </v-layout>
  </v-slide-y-transition>
</v-card>
</template>

<script>
export default {
  props: ['now', 'progress'],
  data: () => ({
    expanded: false
  }),
  computed: {
    courseData () {
      return this.$store.getters.courseByKey(this.progress.courseKey)
    },
    courseContent () {
      const contents = []
      if (this.courseData.content) {
        for (let key of this.courseData.content) {
          contents.push(this.$store.getters.contentByKey(key))
        }
      }
      return contents
    },
    getTimeLeft () {
      return (endTime, onlineDays) => {
        if (endTime > 0) {
          if (this.now < endTime) {
            let time = this.$store.getters.time
            let difference = endTime - this.now
            let timeLeftString = ''
            if (difference > time.day) {
              let daysLeft = difference / time.day
              let hrsLeft = (difference % time.day) / time.hour
              timeLeftString = Math.floor(daysLeft)
              timeLeftString += Math.floor(daysLeft) === 1 ? ' day' : ' days'
              timeLeftString += Math.floor(hrsLeft) > 0 ? ' and ' + Math.floor(hrsLeft) : ' left'
              timeLeftString += Math.floor(hrsLeft) === 1 ? ' hour left' : ' hours left'
            } else if (difference > time.hour) {
              let hrsLeft = difference / time.hour
              let minsLeft = (difference % time.hour) / time.minute
              timeLeftString = Math.floor(hrsLeft)
              timeLeftString += Math.floor(hrsLeft) === 1 ? ' hour' : ' hours'
              timeLeftString += Math.floor(minsLeft) > 0 ? ' and ' + Math.floor(minsLeft) : ' left'
              timeLeftString += Math.floor(minsLeft) === 1 ? ' minute left' : ' minutes left'
            } else {
              let minsLeft = difference / time.minute
              let secsLeft = (difference % time.minute) / time.second
              timeLeftString = Math.floor(minsLeft)
              timeLeftString += Math.floor(minsLeft) === 1 ? ' minute' : ' minutes'
              timeLeftString += Math.floor(secsLeft) > 0 ? ' and ' + Math.floor(secsLeft) : ' left'
              timeLeftString += Math.floor(secsLeft) === 1 ? ' second left' : ' seconds left'
            }
            return timeLeftString
          } else return 'Ended on ' + (new Date(endTime)).toLocaleString()
        } else return onlineDays + ' days left - Not Started'
      }
    }
  },
  methods: {
    goToCourse (progressKey) {
      this.$store.dispatch('setCurrentProgress', {progress: progressKey, section: null, task: null})
      this.$router.push('/my-courses/course-view')
    },
    startCourse (p) {
      let newProgress = {...p}
      newProgress.endTime = this.now + (parseInt(this.courseData.onlineDays) * this.$store.getters.time.day)
      this.$store.dispatch('updateProgress', newProgress).then(() => {
        this.goToCourse(p.key)
      })
    },
    completeCourse (p) {
      let newProgress = {...p}
      newProgress.complete = true
      this.$store.dispatch('updateProgress', newProgress)
    },
    isCourseComplete (progressKey) {
      const course = this.$store.getters.courseByKey(this.progress.courseKey)
      let complete = true
      if (course.content) {
        for (let contentKey of course.content) {
          for (let section of this.$store.getters.sectionByContent(contentKey)) {
            if (!this.isSectionComplete(section.key)) complete = false
          }
        }
      } else complete = false
      return complete
    },
    isSectionComplete (sectionKey) {
      let tasks = this.$store.getters.taskBySection(sectionKey)
      let taskProgress = null
      let complete = false
      if (tasks.length > 0) {
        for (let t of tasks) {
          taskProgress = this.$store.getters.taskProgressByTaskByProgress(t.key, this.currentProgress.progress)
          complete = taskProgress ? taskProgress.complete : false
          if (taskProgress) complete = taskProgress.endTime ? (this.now > taskProgress.endTime) : complete
        }
      } else complete = true
      return complete
    }
  }
}
</script>

<style>
.title-bg {
  background: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
}
.status-text {
  font-size: 120%;
}
.quill-card h1,
.quill-card h2,
.quill-card h3 {
  margin-bottom: 5px;
}
.quill-card p {
  margin: 0 0 5px 0;
  line-height: 120%;
}
.quill-card li {
  margin: 0 0 5px 0;
  line-height: 120%;
}
.quill-card ol, .quill-card ul {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/myCourses/ProgressCard.vue